/* cl-interactive (maison-corval; base nubelle): camada de interacao do clone do Focal 12 dele. O theme.js do Focal nao
   existe aqui e os custom elements dele foram renomeados para cl-* (o main.js do Shrine registra nomes
   iguais). Escopo: secoes copiadas (div[class*="cl-sec-"]) e o buybox (.cl-pdp-host).
   1. arraste de MOUSE em todo trilho horizontal rolavel (toque ja e nativo: overflow-x + snap)
   2. cl-native-carousel + cl-page-dots: itens com [hidden] (fade) ou trilho rolavel; dots + swipe por toque
   3. cl-scrollable-content + cl-prev-next-buttons: setas rolam um item
   4. collapsibles do Focal (button[aria-controls] -> cl-collapsible-content) e <details> com animacao
   5. videos autoplay: muted + play quando entram na tela */
(function () {
  var ROOT = '[class*="cl-sec-"],.cl-pdp-host';
  function scrollable(el) {
    if (!el || el.nodeType !== 1) return false;
    var cs = getComputedStyle(el);
    return (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 2;
  }
  function findTrack(t) {
    for (var el = t; el && el !== document.body; el = el.parentElement) {
      if (scrollable(el)) return el;
      if (el.matches && el.matches(ROOT)) break;
    }
    return null;
  }
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (!e.target.closest(ROOT)) return;
    if (e.target.closest('input,select,textarea,[data-no-drag]')) return;
    var tr = findTrack(e.target);
    if (!tr) return;
    drag = { el: tr, x: e.clientX, left: tr.scrollLeft, moved: false, snap: tr.style.scrollSnapType, beh: tr.style.scrollBehavior };
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.el.style.scrollSnapType = 'none';
      drag.el.style.scrollBehavior = 'auto';
      drag.el.classList.add('cl-dragging');
    }
    if (drag.moved) { drag.el.scrollLeft = drag.left - dx; e.preventDefault(); }
  }, { passive: false });
  function end() {
    if (!drag) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    d.el.classList.remove('cl-dragging');
    var left = d.el.scrollLeft;
    d.el.style.scrollSnapType = d.snap;
    d.el.scrollLeft = left;
    d.el.style.scrollBehavior = d.beh;
    var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
    d.el.addEventListener('click', kill, { capture: true, once: true });
    setTimeout(function () { d.el.removeEventListener('click', kill, { capture: true }); }, 350);
  }
  window.addEventListener('pointerup', end);
  window.addEventListener('pointercancel', end);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[class*="cl-sec-"] a, [class*="cl-sec-"] img, .cl-pdp-host img')) {
      if (findTrack(e.target)) e.preventDefault();
    }
  });
  var st = document.createElement('style');
  st.textContent = '.cl-dragging{cursor:grabbing!important;user-select:none}.cl-dragging *{pointer-events:none}' +
    '.cl-collapsing{overflow:hidden;transition:height .3s ease}';
  document.head.appendChild(st);
})();

(function () {
  var ROOT = '[class*="cl-sec-"],.cl-pdp-host';
  function visible(el) { return el && el.offsetParent !== null && getComputedStyle(el).display !== 'none'; }

  /* 2. native-carousel (+ page-dots) */
  function initCarousel(car) {
    if (car.__clCar) return; car.__clCar = true;
    var root = car.closest('.cl-shopify-section, section, [class*="cl-sec-"]') || car.parentElement;
    var items = function () { return [].slice.call(car.querySelectorAll('cl-native-carousel-item')).filter(function (x) { return x.parentElement && x.parentElement.closest('cl-native-carousel') === car; }); };
    var dotsEl = (car.querySelector('cl-page-dots') || (root && root.querySelector('cl-page-dots')));
    var dots = function () { return dotsEl ? [].slice.call(dotsEl.querySelectorAll('button')) : []; };
    var list = items();
    if (list.length < 2) return;
    var track = list[0].parentElement;
    var at = Math.max(0, list.map(function (x) { return !x.hasAttribute('hidden'); }).indexOf(true));
    function hiddenMode() {   // fade do Focal no mobile: so o item ativo visivel
      return list.some(function (x) { return x.hasAttribute('hidden') && getComputedStyle(x).display === 'none'; }) || !scrollableTrack();
    }
    function scrollableTrack() { var cs = getComputedStyle(track); return (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && track.scrollWidth > track.clientWidth + 2; }
    function mark(i) {
      at = i;
      dots().forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      i = (i + list.length) % list.length;
      if (scrollableTrack() && !hiddenMode()) {
        track.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
      } else {
        list.forEach(function (x, k) { if (k === i) x.removeAttribute('hidden'); else x.setAttribute('hidden', ''); });
      }
      mark(i);
    }
    if (dotsEl) dotsEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      e.preventDefault(); go(dots().indexOf(b));
    });
    track.addEventListener('scroll', function () {
      if (!scrollableTrack()) return;
      var w = list[0].offsetWidth || 1, i = Math.round(track.scrollLeft / w);
      if (i !== at && i < list.length) mark(i);
    }, { passive: true });
    // swipe por toque no modo fade
    var sx = null, sy = null;
    car.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    car.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && hiddenMode()) go(at + (dx < 0 ? 1 : -1));
    }, { passive: true });
    // arraste de mouse no modo fade
    var mx = null;
    car.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') mx = e.clientX; });
    car.addEventListener('pointerup', function (e) {
      if (mx === null) return; var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) > 40 && hiddenMode()) go(at + (dx < 0 ? 1 : -1));
    });
  }

  /* 3. scrollable-content + prev-next-buttons */
  function initScroller(sc) {
    if (sc.__clSc) return; sc.__clSc = true;
    var root = sc.closest('[class*="cl-sec-"]') || document;
    var pn = root.querySelector('cl-prev-next-buttons');
    if (!pn) return;
    var bs = pn.querySelectorAll('button');
    var prev = pn.querySelector('[class*="--prev"]') || bs[0], next = pn.querySelector('[class*="--next"]') || bs[bs.length - 1];
    function step() { var f = sc.firstElementChild; var gap = parseFloat(getComputedStyle(sc).columnGap) || 0; return f ? f.getBoundingClientRect().width + gap : sc.clientWidth; }
    function sync() {
      var max = sc.scrollWidth - sc.clientWidth - 1;
      if (prev) prev.disabled = sc.scrollLeft <= 1;
      if (next) next.disabled = sc.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); sc.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); sc.scrollBy({ left: step(), behavior: 'smooth' }); });
    sc.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  /* 4. collapsibles do Focal */
  function setOpen(btn, panel, open, animate) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) panel.setAttribute('open', ''); else panel.removeAttribute('open');
    var inner = panel;
    if (!animate) {
      panel.style.height = open ? 'auto' : '0px';
      panel.style.overflow = open ? '' : 'hidden';
      panel.style.visibility = open ? 'visible' : 'hidden';
      return;
    }
    var from = panel.getBoundingClientRect().height;
    panel.style.visibility = 'visible';
    panel.style.height = 'auto';
    var to = open ? panel.scrollHeight : 0;
    panel.style.height = from + 'px';
    panel.classList.add('cl-collapsing');
    requestAnimationFrame(function () {
      panel.style.height = to + 'px';
      setTimeout(function () {
        panel.classList.remove('cl-collapsing');
        panel.style.height = open ? 'auto' : '0px';
        panel.style.overflow = open ? '' : 'hidden';
        if (!open) panel.style.visibility = 'hidden';
      }, 320);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[aria-controls], [role="button"][aria-controls]');
    if (!btn || !btn.closest('[class*="cl-sec-"],.cl-pdp-host')) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel || !/collapsible/i.test(panel.tagName + ' ' + panel.className)) return;
    e.preventDefault();
    setOpen(btn, panel, btn.getAttribute('aria-expanded') !== 'true', true);
  });


  /* 6. popover do Focal (seletor de pais do rodape): botao aria-controls -> cl-popover-content[open] */
  document.addEventListener('click', function (e) {
    var close = e.target.closest('cl-popover-content [data-action="close"], cl-popover-content .popover__overlay');
    var openPop = document.querySelectorAll('cl-popover-content[open]');
    if (close) { var pp = close.closest('cl-popover-content'); pp.removeAttribute('open');
      var ob = document.querySelector('[aria-controls="' + pp.id + '"]'); if (ob) ob.setAttribute('aria-expanded', 'false'); return; }
    var btn = e.target.closest('button[aria-controls]');
    var panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (panel && panel.tagName === 'CL-POPOVER-CONTENT') {
      e.preventDefault();
      var willOpen = !panel.hasAttribute('open');
      if (willOpen) panel.setAttribute('open', ''); else panel.removeAttribute('open');
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    openPop.forEach(function (pp) { if (!pp.contains(e.target)) { pp.removeAttribute('open');
      var ob = document.querySelector('[aria-controls="' + pp.id + '"]'); if (ob) ob.setAttribute('aria-expanded', 'false'); } });
  });

  /* 5. videos */
  function initVideo(v) {
    if (v.__clV) return; v.__clV = true;
    if (!(v.autoplay || v.hasAttribute('autoplay') || v.hasAttribute('data-autoplay') || v.closest('[autoplay]'))) return;
    v.muted = true; v.setAttribute('playsinline', '');
    if (!v.hasAttribute('loop')) v.loop = true;
    var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) play(); else try { v.pause(); } catch (e) {} }); }, { rootMargin: '200px 0px' }).observe(v);
    } else play();
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(function (r) {
      r.querySelectorAll('cl-native-carousel').forEach(initCarousel);
      r.querySelectorAll('cl-scrollable-content').forEach(initScroller);
      r.querySelectorAll('video').forEach(initVideo);
      // collapsibles: estado inicial coerente (o extract pode ter gravado abertos)
      r.querySelectorAll('button[aria-controls]').forEach(function (b) {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p && /collapsible/i.test(p.tagName + ' ' + p.className) && !p.__clInit) {
          p.__clInit = true;
          setOpen(b, p, b.getAttribute('aria-expanded') === 'true', false);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
